import { CashReceiptTransaction } from '../../../utils/types/cashReceipt.type';
import { DetailsType } from '../../../utils/types/form.type';

export const UPDATE_TRANSACTION_ERROR =
  'Error in updating transaction details.';
export const UPDATE_TRANSACTION_SUCCESS =
  'Transaction details updated successfully.';
export const UPDATE_ADJUSTMENT_SUCCESS = 'Adjustments updated successfully.';
export const UPDATE_ADJUSTMENT_ERROR = 'Error in updating adjustments.';

export enum TransactionAction {
  NotifyAndSendToGL = 'notify_and_send',
  Notify = 'notify',
  SendToGL = 'send_to_gl',
  ExportAll = 'export_all',
  ExportSelected = 'export_selected',
}

export const csvHeaders = [
  { label: 'fund', key: 'fund' },
  { label: 'investor', key: 'investor' },
  { label: 'amount_owed', key: 'amount' },
  { label: 'amount_paid', key: 'amountPaid' },
  { label: 'cash_received', key: 'cashReceived' },
  { label: 'date_of_receipt', key: 'receiptDate' },
  { label: 'notified', key: 'notified' },
];

export type SelectedCashReceiptTransaction = {
  transaction?: CashReceiptTransaction;
  investor?: { id: string; name: string };
  type?: DetailsType;
};
